import React from 'react'

/** Palet warna kepala pin (rotasi per-item mengikuti palet dekor login) */
export const PIN_COLORS = ['#e8554d', '#4678f3', '#46be8a', '#f39834']

/**
 * Paku payung glossy dekoratif (tampak depan menancap): bayangan jatuh kepala di kertas,
 * lubang tusukan, jarum pendek masuk kertas, kepala bola berwarna + shading + highlight.
 * Warna kepala lewat prop `color` (dipetakan ke currentColor pada SVG).
 */
const PushPin = ({ color = '#4678f3', className }) => (
  <svg viewBox="0 0 38 42" className={className} style={{ color }} aria-hidden="true">
    <ellipse cx="24" cy="35" rx="10" ry="3.4" fill="#1f2d5c" opacity="0.16" />
    <circle cx="19.8" cy="33.6" r="1.4" fill="#4d5568" opacity="0.85" />
    <path d="M 18.6 26.5 L 19.7 33.2" stroke="#9aa3b8" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M 18.6 26.5 L 19.7 33.2" stroke="#dde2ec" strokeWidth="0.9" strokeLinecap="round" />
    <circle cx="18" cy="15" r="12" fill="currentColor" />
    <path
      d="M 6.6 18.5 A 12 12 0 0 0 29.2 19.2 A 15 11 0 0 1 6.6 18.5"
      fill="rgba(31, 45, 92, 0.25)"
    />
    <circle cx="18" cy="15" r="12" fill="none" stroke="rgba(31, 45, 92, 0.2)" strokeWidth="1" />
    <ellipse
      cx="13.6"
      cy="10.4"
      rx="4.6"
      ry="3.1"
      fill="#ffffff"
      opacity="0.65"
      transform="rotate(-32 13.6 10.4)"
    />
    <circle cx="22.6" cy="9.2" r="1.4" fill="#ffffff" opacity="0.5" />
  </svg>
)

export default PushPin
